import { useRef } from 'react'

const useVocabulary = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null)

  const handlePlayAudio = async (file: any, speed = 1) => {
    try {
      // Dừng và cleanup audio cũ
      if (audioRef.current) {
        audioRef.current.pause()
        audioRef.current.currentTime = 0
        audioRef.current.src = ''
        audioRef.current.remove()

        // Đợi audio cũ cleanup hoàn toàn
        await new Promise<void>((resolve) => {
          audioRef.current?.addEventListener('emptied', () => {
            audioRef.current = null
            resolve()
          }, { once: true })
        })
      }

      // Tạo audio mới
      const audio = new Audio()
      audioRef.current = audio // Gán ngay để tránh race condition

      audio.src = file
      audio.playbackRate = speed

      // Đợi audio load xong
      await new Promise((resolve, reject) => {
        audio.addEventListener('canplaythrough', resolve, { once: true })
        audio.addEventListener('error', reject, { once: true })
        audio.load()
      })

      await audio.play()
    } catch (error) { }
  }

  const handlePauseAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause()
      audioRef.current.currentTime = 0
      audioRef.current = null
    }
  }

  return { handlePlayAudio, handlePauseAudio }
}

export default useVocabulary